<template>
  <div class="detailview">
    <b-card align="left" border-variant="dark">
      <b-card-title>
        <b-container fluid @click="$bvModal.show('view-'+log.objectID)">
          <b-row align-v="top">
            <b-col align-self="start" cols="7" sm="10">
              {{ log.log }}
            </b-col>
          </b-row>
        </b-container>
      </b-card-title>
      <div class="time" v-b-tooltip.hover.top :title="logTimeTooltipString">
        {{ logTimeString }}
      </div>
      <div>
        <b-badge class="label" variant="dark">{{ log.target }}</b-badge>
        <b-badge class="label" variant="dark">{{ log.version}}</b-badge>
      </div>
      <b-container fluid>
        <h3><b-badge pill variant="info">Cause</b-badge></h3>
        <markdown-it-vue class="md-body" :content="this.log.cause" />
        <h3><b-badge pill variant="info">Action</b-badge></h3>
        <markdown-it-vue class="md-body" :content="this.log.action" />
      </b-container>
    </b-card>
  </div>
</template>

<script>
import MarkdownItVue from 'markdown-it-vue'
import 'markdown-it-vue/dist/markdown-it-vue.css'
import moment from 'moment'
export default {
  name: 'DetailView',
  props: ['log'],
  components: {
    MarkdownItVue
  },
  methods: {
  },
  computed: {
    logTimeString() {
      let created_time = moment(this.log.created_at)
      let updated_time = moment(this.log.updated_at)
      if(created_time.isBefore(updated_time)) {
        return '(updated)' + updated_time.fromNow()
      } else {
        return created_time.fromNow()
      }
    },
    logTimeTooltipString() {
      let created_time = moment(this.log.created_at)
      let updated_time = moment(this.log.updated_at)
      if(created_time.isBefore(updated_time)) {
        return updated_time.format("YYYY/MM/DD HH:mm:ss")
      } else {
        return created_time.format("YYYY/MM/DD HH:mm:ss")
      }
    },
  }
}
</script>

<style>
.detailview {
  padding: 1.5rem;
}
.md-body {
  border-color: #e9ecef;
  border-width: 1px;
}
</style>
